<template>
  <div class='gscAuthorization'>
    <!-- GSC -->
    <client-module moduletitle="Google Search Console 授权管理">
      <data-list :table-style="{ name: 'mixture' }"
                 :data="data"
                 :columns="columns"
                 :loading="loading"
                 :page="page"
                 :page-size="page.pageSize"
                 @page-size-changed="pageSizeChanged"
                 @page-changed="pageChanged"></data-list>
    </client-module>

    <!-- Gsc授权表单 -->
    <gscAuthorizationForm ref="gscAuthorizationForm"
                          dialogWidth="500px"
                          title="授权Google Search Console" />
  </div>
</template>

<script>
import clientModule from '@/components/client/clientModule/clientModule';
import listPageCreate from '@/mixins/listPageCreate';
import authorizedAccount from './authorizedAccount.vue';
import gscAuthorizationForm from './form/gscAuthorizationForm.vue';
import api from '@/backend/apiConfig/apiConfig';

const list = listPageCreate({
  searchConfig: {
    api: api.website.gscList,
    method: 'GET',
  },
  setExtension: (self) => {
    return {
      PathParam: {
        id: self.zjzProjectId
      }
    }
  },
  afterResponse: (res) => {
    return {
      data: {
        data: res.data
      }
    }
  }
});

export default {
  name: 'gscAuthorization',
  props: ['zjzProjectId'],
  mixins: [list],
  components: {
    clientModule,
    gscAuthorizationForm
  },
  provide () {
    //  0 全部线索  1 线索列表详情  2 公海线索  3 垃圾线索
    return {
      showForm: this.showForm,
      query: this.query
    }
  },
  data () {
    let that = this
    return {
      columns: [
        {
          label: '',
          type: 'tableExpand',
          width: 60,
          tagName: authorizedAccount,
        },
        {
          label: '域名',
          bind: 'domain',
        },
        {
          label: '语种',
          bind: 'langName',
        },
        {
          label: '状态',
          bind: (res) => {
            let { status } = res
            switch (status) {
              case 0:
                return '待解析'
              case 1:
                return '验证中'
              case 2:
                return '已验证'
              case 3:
                return '验证失败'
              default:
                return '-'
            }
          },
        },
        {
          label: '验证时间',
          bind: 'updateAt',
        },
        {
          label: '授权账号',
          bind: (row) => {
            let { members } = row
            let val = ''
            if (members) {
              members.forEach((item, index) => {
                val += index === members.length - 1 ? item.account : `${item.account},`
              })
            }
            return val || "-"
          }
        },
        {
          label: '操作',
          type: 'btnClick',
          style: 'text',
          bind: () => {
            return [
              {
                text: '授权账号',
                trigger: row => {
                  that.showForm(row)
                },
              },
            ];
          },
        },
      ],
    }
  },
  watch: {
    zjzProjectId: {
      handler () {
        this.query();
      },
    }
  },
  methods: {
    async showForm (row) {
      let { cancel } = await this.$refs.gscAuthorizationForm.show(row)
      if (!cancel) {
        this.query()
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.gscAuthorization {
	.client-module {
		background-color: #fff;
		box-shadow: 0 4px 4px 0 rgba(67, 93, 255, 0.05);

		.module-main {
			width: 100%;
			padding: 15px 20px;
		}
	}
}
</style>
